import {Door} from "./door";
import {setSturzRiegelHeight, sturzRiegelHeight} from "../../constants/cutOuts/interiorDoorConstants";
import * as THREE from "three";
import {Vector3} from "three";
import * as Globals from "../../globals";
import {
    defaultSchwelleHeight,
    defaultWallElementHeight,
    interiorDoorHeights,
    interiorDoorSturzRiegelHeights
} from "../../globals";
import {wallMaterial} from "../../constants/materialConstants";
import {setObjectLayer} from "../../utils/layerUtils";
import {recalculateBuildingParameters} from "../../calculators/buildingParameters/parameterCalculator";
import {getKeyByValue} from "../../utils/utils";
import {addEdgeGeometry} from "../../utils/threeUtils";
import {getVolume} from "../../utils/volumeUtils";

export class InteriorDoor extends Door {
    constructor(interiorDoorPreview) {
        super(interiorDoorPreview);
        this.setHeightToWallHeight = false;
    }

    create(wallGroup = null, wallMeshName = null) {
        let result = super.create(wallGroup, wallMeshName);
        if (result) {
            this.cutOutGroup.name = "interiorDoorGroup";
            this.insertSturzRiegel();
            recalculateBuildingParameters().then();
        }

        return result;
    }

    insertSturzRiegel() {
        //Sturzriegel Höhe festlegen
        let key = getKeyByValue(interiorDoorHeights, this.height);
        if (interiorDoorSturzRiegelHeights.hasOwnProperty(key)) {
            setSturzRiegelHeight(interiorDoorSturzRiegelHeights[key]);
        } else {
            setSturzRiegelHeight(0);
            console.error("Ungültige Sturzriegel Höhe.");
        }

        if (sturzRiegelHeight <= 0) {
            //Bei manchen Konfigurationen kann es sein, dass kein Sturzriegel nötig ist. Dann brauch dies auch nicht ausgeführt werden.
            //In diesen Fällen dient das Rähm als Sturzriegel da die Tür auf die volle Wandelementlänge hat.
            return;
        }
        let sturzRiegel = new THREE.Mesh(new THREE.BoxGeometry(this.width, sturzRiegelHeight, Globals.HBEWallDefaultThickness), wallMaterial);
        sturzRiegel.name = "sturzRiegel";
        this.cutOutGroup.addWithUuid(sturzRiegel);
        sturzRiegel.position.set(this.cutMesh.position.x, this.cutMesh.position.y, 0); //Grundposition
        //Aktuelle Y Position in der Welt bestimmen
        let worldPosition = sturzRiegel.getWorldPosition(new Vector3()).y;
        //Differenz zur Welt Y Position und soll Welt Y Position
        let diff = (defaultSchwelleHeight + defaultWallElementHeight - (0.5 * sturzRiegelHeight)) - worldPosition;
        //Differenz auf den Sturzriegel innerhalb der Gruppe anwenden > Z Koordinate
        sturzRiegel.position.setZ(-diff);
        sturzRiegel.rotateX(Math.PI / 2);
        sturzRiegel.updateMatrix();
        addEdgeGeometry(sturzRiegel);
        setObjectLayer(sturzRiegel, Globals.layers.wall, true);
        sturzRiegel.userData = {
            width: this.width,
            depth: Globals.HBEWallDefaultThickness,
            height: sturzRiegelHeight,
            originalVolume: getVolume(sturzRiegel.geometry)
        };
    }

    setControlObjectUserData(wallMeshName, sceneMatrix) {
        super.setControlObjectUserData(wallMeshName, sceneMatrix);
        this.controlObject.userData.type = "interiorDoor";
    }
}
